var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { CareAppListActionFactory } from './action-factory';
var OrganisationActions = /** @class */ (function (_super) {
    __extends(OrganisationActions, _super);
    function OrganisationActions() {
        return _super.call(this, "Organisations") || this;
    }
    Object.defineProperty(OrganisationActions.prototype, "REQUEST_OWN", {
        get: function () {
            return "[" + this.type + "][Request] own";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrganisationActions.prototype, "RESPONSE_SUCCESS_OWN", {
        get: function () {
            return "[" + this.type + "][Response][Success] own";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrganisationActions.prototype, "RESPONSE_FAIL_OWN", {
        get: function () {
            return "[" + this.type + "][Response][Fail] own";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrganisationActions.prototype, "REQUEST_PREFERENCES", {
        get: function () {
            return "[" + this.type + "][Request] Organisation Preferences";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrganisationActions.prototype, "RESPONSE_SUCCESS_PREFERENCES", {
        get: function () {
            return "[" + this.type + "][Response][Success] Organisation Preferences";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrganisationActions.prototype, "RESPONSE_FAIL_PREFERENCES", {
        get: function () {
            return "[" + this.type + "][Response][Fail] Organisation Preferences";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrganisationActions.prototype, "UPDATE_PREFERENCES", {
        get: function () {
            return "[" + this.type + "][Request] Save Organisation Preferences";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrganisationActions.prototype, "SUCCESS_UPDATE_PREFERENCES", {
        get: function () {
            return "[" + this.type + "][Response][Success] Save Organisation Preferences";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrganisationActions.prototype, "FAIL_UPDATE_PREFERENCES", {
        get: function () {
            return "[" + this.type + "][Response][Fail] Save Organisation Preferences";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrganisationActions.prototype, "REQUEST_BRANDING", {
        get: function () {
            return "[" + this.type + "][Request] Organisation Branding";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrganisationActions.prototype, "RESPONSE_SUCCESS_BRANDING", {
        get: function () {
            return "[" + this.type + "][Response][Success] Organisation Branding";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrganisationActions.prototype, "RESPONSE_FAIL_BRANDING", {
        get: function () {
            return "[" + this.type + "][Response][Fail] Organisation Branding";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrganisationActions.prototype, "UPDATE_BRANDING_COLORS", {
        get: function () {
            return "[" + this.type + "][Request] Save Organisation Branding Colors";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrganisationActions.prototype, "RESET_BRANDING_COLORS", {
        get: function () {
            return "[" + this.type + "][Request] Reset Organisation Branding Colors";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrganisationActions.prototype, "SUCCESS_UPDATE_BRANDING_COLORS", {
        get: function () {
            return "[" + this.type + "][Response][Success] Save Organisation Branding Colors";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrganisationActions.prototype, "FAIL_UPDATE_BRANDING_COLORS", {
        get: function () {
            return "[" + this.type + "][Response][Fail] Save Organisation Branding Colors";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrganisationActions.prototype, "UPDATE_BRANDING_IMAGE", {
        get: function () {
            return "[" + this.type + "][Request] Save Organisation Branding Image";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrganisationActions.prototype, "REMOVE_BRANDING_IMAGE", {
        get: function () {
            return "[" + this.type + "][Request] Remove Organisation Branding Image";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrganisationActions.prototype, "SUCCESS_UPDATE_BRANDING_IMAGE", {
        get: function () {
            return "[" + this.type + "][Response][Success] Save Organisation Branding Image";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrganisationActions.prototype, "FAIL_UPDATE_BRANDING_IMAGE", {
        get: function () {
            return "[" + this.type + "][Response][Fail] Save Organisation Branding Image";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrganisationActions.prototype, "NO_VALID_ORGANISATIONS", {
        get: function () {
            return "[" + this.type + "][Fail] No Valid Organisations";
        },
        enumerable: true,
        configurable: true
    });
    OrganisationActions.prototype.RequestOwn = function () {
        return { type: this.REQUEST_OWN };
    };
    OrganisationActions.prototype.ResponseSuccessOwn = function (payload) {
        return { type: this.RESPONSE_SUCCESS_OWN, payload: payload };
    };
    OrganisationActions.prototype.ResponseFailOwn = function (payload) {
        return { type: this.RESPONSE_FAIL_OWN, payload: payload };
    };
    OrganisationActions.prototype.RequestPreferences = function () {
        return { type: this.REQUEST_PREFERENCES };
    };
    OrganisationActions.prototype.ResponseSuccessPreferences = function (payload) {
        return { type: this.RESPONSE_SUCCESS_PREFERENCES, payload: payload };
    };
    OrganisationActions.prototype.ResponseFailPreferences = function (payload) {
        return { type: this.RESPONSE_FAIL_PREFERENCES, payload: payload };
    };
    OrganisationActions.prototype.UpdatePreferences = function (payload) {
        return { type: this.UPDATE_PREFERENCES, payload: payload };
    };
    OrganisationActions.prototype.SuccessUpdatePreferences = function (payload) {
        return { type: this.SUCCESS_UPDATE_PREFERENCES, payload: payload };
    };
    OrganisationActions.prototype.FailUpdatePreferences = function (payload) {
        return { type: this.FAIL_UPDATE_PREFERENCES, payload: payload };
    };
    OrganisationActions.prototype.RequestBranding = function () {
        return { type: this.REQUEST_BRANDING };
    };
    OrganisationActions.prototype.ResponseSuccessBranding = function (payload) {
        return { type: this.RESPONSE_SUCCESS_BRANDING, payload: payload };
    };
    OrganisationActions.prototype.ResponseFailBranding = function (payload) {
        return { type: this.RESPONSE_FAIL_BRANDING, payload: payload };
    };
    OrganisationActions.prototype.UpdateBrandingColors = function (payload) {
        return { type: this.UPDATE_BRANDING_COLORS, payload: payload };
    };
    OrganisationActions.prototype.RequestResetBrandingColors = function () {
        return { type: this.RESET_BRANDING_COLORS };
    };
    OrganisationActions.prototype.SuccessUpdateBrandingColors = function (payload) {
        return { type: this.SUCCESS_UPDATE_BRANDING_COLORS, payload: payload };
    };
    OrganisationActions.prototype.FailUpdateBrandingColors = function (payload) {
        return { type: this.FAIL_UPDATE_BRANDING_COLORS, payload: payload };
    };
    OrganisationActions.prototype.UpdateBrandingImage = function (payload) {
        return { type: this.UPDATE_BRANDING_IMAGE, payload: payload };
    };
    OrganisationActions.prototype.RemoveBrandingImage = function (payload) {
        return { type: this.REMOVE_BRANDING_IMAGE, payload: payload };
    };
    OrganisationActions.prototype.SuccessUpdateBrandingImage = function (payload) {
        return { type: this.SUCCESS_UPDATE_BRANDING_IMAGE, payload: payload };
    };
    OrganisationActions.prototype.FailUpdateBrandingImage = function (payload) {
        return { type: this.FAIL_UPDATE_BRANDING_IMAGE, payload: payload };
    };
    OrganisationActions.prototype.NoValidOrganisations = function () {
        return { type: this.NO_VALID_ORGANISATIONS };
    };
    return OrganisationActions;
}(CareAppListActionFactory));
export var Organisations = new OrganisationActions();
